// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: var(--gradient-bg, linear-gradient(135deg, #667eea 0%, #764ba2 100%));
    min-height: 100vh;
    /* Theme-flipping ink: dark mode → near-white, light mode → dark (see
       constants/themes.js LIGHT_MODE_VARS). Was a hardcoded #fff, which left
       every element that inherits the body colour — e.g. classless page
       headings like "My Expeditions" — invisible in light mode. */
    color: var(--text-primary);
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
}

.container {
    max-width: 1600px;
    margin: 0 auto;
    padding: 20px;
}

.header {
    text-align: center;
    padding: 40px 20px;
}

.header h1 {
    font-size: 3rem;
    margin-bottom: 10px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.header p {
    font-size: 1.2rem;
    opacity: 0.9;
}

.nav {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 40px;
    flex-wrap: wrap;
}

.nav button {
    padding: 12px 24px;
    font-size: 1rem;
    background: rgba(255, 255, 255, 0.2);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 600;
}

.nav button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
}

.nav button.active {
    background: rgba(255, 255, 255, 0.4);
    border-color: rgba(255, 255, 255, 0.6);
}

.card {
    background: var(--glass-bg);
    border-radius: 12px;
    padding: 20px;
    backdrop-filter: blur(10px);
    border: 1px solid var(--glass-border);
    margin-bottom: 20px;
}

.card h2 {
    margin-bottom: 15px;
    font-size: 1.5rem;
}

.card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    margin-top: 20px;
}

.card-focus-banner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin: 15px 0;
    padding: 12px 15px;
    background: var(--glass-bg-strong);
    border: 1px solid #667eea;
    border-radius: 8px;
    font-size: 0.95rem;
}

.card-focus-banner__clear {
    padding: 6px 14px;
    background: #667eea;
    border: none;
    border-radius: 5px;
    color: white;
    font-weight: bold;
    cursor: pointer;
}

.card-focus-banner__clear:hover {
    background: #5568d3;
}

.card-item {
    background: var(--glass-bg-strong);
    border-radius: 12px;
    padding: 15px;
    transition: transform 0.3s ease;
    cursor: pointer;
    border: 2px solid transparent;
}

.card-item:hover {
    transform: translateY(-5px);
    border-color: var(--glass-border-strong);
}

/* Date images can be portrait (~2:3) or landscape (~11:8). The frame follows the
   image's natural ratio and is capped at 300px tall, so a landscape image renders
   short and wide instead of being letterboxed inside a tall portrait frame. */
.card-image {
    width: 100%;
    height: auto;
    max-height: 300px;
    object-fit: contain;
    border-radius: 8px;
    margin-bottom: 10px;
    background: rgba(0, 0, 0, 0.2);
}

/* Non-image placeholders reuse .card-image and keep the fixed portrait frame */
div.card-image {
    height: 300px;
}

/* Dateless card placeholder */
.card-no-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1a1a2e, #16213e) !important;
    gap: 8px;
}

.no-date-icon {
    font-size: 2rem;
    opacity: 0.4;
}

.no-date-text {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.4);
    font-weight: 500;
}

/* Date Generation Counter */
.date-gen-counter {
    margin-top: 20px;
}

.date-gen-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

.date-gen-stats {
    display: flex;
    gap: 16px;
    margin-top: 4px;
}

.date-gen-stat {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
}

.date-gen-stat.bonus {
    color: #a855f7;
}

.date-gen-warning {
    display: block;
    margin-top: 4px;
    font-size: 0.8rem;
    color: #f59e0b;
}

.date-gen-exhausted {
    display: block;
    margin-top: 4px;
    font-size: 0.8rem;
    color: #ef4444;
}

.skip-first-date-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 0.9rem;
    white-space: nowrap;
}

.skip-first-date-toggle input:disabled + span {
    opacity: 0.5;
}

.confirm-modal-skip {
    margin-top: 12px;
}

.first-date-preset-picker {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
    font-size: 0.9rem;
}

.first-date-preset-picker select {
    flex: 1 1;
    min-width: 0;
    padding: 6px 8px;
    background: #2a2a2a;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 6px;
}

.first-date-preset-hint {
    flex-basis: 100%;
    font-size: 0.8rem;
    opacity: 0.75;
}

.card-name {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 5px;
}

.card-stats {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-size: 0.9rem;
    opacity: 0.9;
}

.button {
    padding: 12px 24px;
    font-size: 1rem;
    background: var(--gradient-primary, linear-gradient(135deg, #667eea 0%, #764ba2 100%));
    border: none;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 600;
}

.button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
}

.form-group input,
.form-group textarea,
.form-group select {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 2px solid var(--glass-border-strong);
    background: var(--glass-bg);
    color: var(--color-white);
    font-size: 1rem;
}

/* Native <select> dropdown options render with the OS popup background, which
   is invisible/unreadable over a translucent glass select. Give them a solid,
   theme-aware background so the option list is legible in every theme + mode. */
select option,
select optgroup {
    background: var(--color-dark-lighter);
    color: var(--color-white);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
    color: var(--color-gray-light);
}

.form-group textarea {
    resize: vertical;
    min-height: 100px;
}

.loading {
    text-align: center;
    padding: 40px;
    font-size: 1.2rem;
}

.error {
    background: rgba(255, 0, 0, 0.2);
    border: 2px solid rgba(255, 0, 0, 0.5);
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
}

.success {
    background: rgba(0, 255, 0, 0.2);
    border: 2px solid rgba(0, 255, 0, 0.5);
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
}

.battle-arena {
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 20px;
    margin: 40px 0;
}

.vs {
    font-size: 3rem;
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.stats-bar {
    background: var(--glass-bg);
    border-radius: 8px;
    padding: 15px;
    margin-top: 20px;
}

.stat-item {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid var(--glass-border);
}

.stat-item:last-child {
    border-bottom: none;
}

.badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: 600;
    margin-left: 8px;
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}

.badge.common {
    background: #95a5a6;
    color: white;
}

.badge.rare {
    background: #3498db;
    color: white;
}

.badge.epic {
    background: #9b59b6;
    color: white;
}

.badge.legendary {
    background: #f39c12;
    color: #1a1a1a;
}

.badge.limited {
    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
    color: white;
    box-shadow: 0 0 10px rgba(231, 76, 60, 0.5);
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT;;kBAEc;IACd,mCAAmC;IACnC,kCAAkC;IAClC,iFAAiF;IACjF,iBAAiB;IACjB;;;kEAG8D;IAC9D,0BAA0B;AAC9B;;AAEA;IACI;iBACa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;;8EAE8E;AAC9E;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA,+EAA+E;AAC/E;IACI,aAAa;AACjB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gEAAgE;IAChE,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sFAAsF;IACtF,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;IAGI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,4CAA4C;IAC5C,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;gFAEgF;AAChF;;IAEI,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,2CAA2C;IAC3C,iBAAiB;AACrB","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background: var(--gradient-bg, linear-gradient(135deg, #667eea 0%, #764ba2 100%));\n    min-height: 100vh;\n    /* Theme-flipping ink: dark mode → near-white, light mode → dark (see\n       constants/themes.js LIGHT_MODE_VARS). Was a hardcoded #fff, which left\n       every element that inherits the body colour — e.g. classless page\n       headings like \"My Expeditions\" — invisible in light mode. */\n    color: var(--text-primary);\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n        monospace;\n}\n\n.container {\n    max-width: 1600px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n.header {\n    text-align: center;\n    padding: 40px 20px;\n}\n\n.header h1 {\n    font-size: 3rem;\n    margin-bottom: 10px;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.header p {\n    font-size: 1.2rem;\n    opacity: 0.9;\n}\n\n.nav {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-bottom: 40px;\n    flex-wrap: wrap;\n}\n\n.nav button {\n    padding: 12px 24px;\n    font-size: 1rem;\n    background: rgba(255, 255, 255, 0.2);\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-radius: 8px;\n    color: white;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: 600;\n}\n\n.nav button:hover {\n    background: rgba(255, 255, 255, 0.3);\n    transform: translateY(-2px);\n}\n\n.nav button.active {\n    background: rgba(255, 255, 255, 0.4);\n    border-color: rgba(255, 255, 255, 0.6);\n}\n\n.card {\n    background: var(--glass-bg);\n    border-radius: 12px;\n    padding: 20px;\n    backdrop-filter: blur(10px);\n    border: 1px solid var(--glass-border);\n    margin-bottom: 20px;\n}\n\n.card h2 {\n    margin-bottom: 15px;\n    font-size: 1.5rem;\n}\n\n.card-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.card-focus-banner {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin: 15px 0;\n    padding: 12px 15px;\n    background: var(--glass-bg-strong);\n    border: 1px solid #667eea;\n    border-radius: 8px;\n    font-size: 0.95rem;\n}\n\n.card-focus-banner__clear {\n    padding: 6px 14px;\n    background: #667eea;\n    border: none;\n    border-radius: 5px;\n    color: white;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.card-focus-banner__clear:hover {\n    background: #5568d3;\n}\n\n.card-item {\n    background: var(--glass-bg-strong);\n    border-radius: 12px;\n    padding: 15px;\n    transition: transform 0.3s ease;\n    cursor: pointer;\n    border: 2px solid transparent;\n}\n\n.card-item:hover {\n    transform: translateY(-5px);\n    border-color: var(--glass-border-strong);\n}\n\n/* Date images can be portrait (~2:3) or landscape (~11:8). The frame follows the\n   image's natural ratio and is capped at 300px tall, so a landscape image renders\n   short and wide instead of being letterboxed inside a tall portrait frame. */\n.card-image {\n    width: 100%;\n    height: auto;\n    max-height: 300px;\n    object-fit: contain;\n    border-radius: 8px;\n    margin-bottom: 10px;\n    background: rgba(0, 0, 0, 0.2);\n}\n\n/* Non-image placeholders reuse .card-image and keep the fixed portrait frame */\ndiv.card-image {\n    height: 300px;\n}\n\n/* Dateless card placeholder */\n.card-no-date {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #1a1a2e, #16213e) !important;\n    gap: 8px;\n}\n\n.no-date-icon {\n    font-size: 2rem;\n    opacity: 0.4;\n}\n\n.no-date-text {\n    font-size: 0.85rem;\n    color: rgba(255, 255, 255, 0.4);\n    font-weight: 500;\n}\n\n/* Date Generation Counter */\n.date-gen-counter {\n    margin-top: 20px;\n}\n\n.date-gen-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n}\n\n.date-gen-stats {\n    display: flex;\n    gap: 16px;\n    margin-top: 4px;\n}\n\n.date-gen-stat {\n    font-size: 0.9rem;\n    color: rgba(255, 255, 255, 0.7);\n}\n\n.date-gen-stat.bonus {\n    color: #a855f7;\n}\n\n.date-gen-warning {\n    display: block;\n    margin-top: 4px;\n    font-size: 0.8rem;\n    color: #f59e0b;\n}\n\n.date-gen-exhausted {\n    display: block;\n    margin-top: 4px;\n    font-size: 0.8rem;\n    color: #ef4444;\n}\n\n.skip-first-date-toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    white-space: nowrap;\n}\n\n.skip-first-date-toggle input:disabled + span {\n    opacity: 0.5;\n}\n\n.confirm-modal-skip {\n    margin-top: 12px;\n}\n\n.first-date-preset-picker {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin-top: 10px;\n    font-size: 0.9rem;\n}\n\n.first-date-preset-picker select {\n    flex: 1;\n    min-width: 0;\n    padding: 6px 8px;\n    background: #2a2a2a;\n    color: #fff;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 6px;\n}\n\n.first-date-preset-hint {\n    flex-basis: 100%;\n    font-size: 0.8rem;\n    opacity: 0.75;\n}\n\n.card-name {\n    font-size: 1.2rem;\n    font-weight: bold;\n    margin-bottom: 5px;\n}\n\n.card-stats {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 10px;\n    font-size: 0.9rem;\n    opacity: 0.9;\n}\n\n.button {\n    padding: 12px 24px;\n    font-size: 1rem;\n    background: var(--gradient-primary, linear-gradient(135deg, #667eea 0%, #764ba2 100%));\n    border: none;\n    border-radius: 8px;\n    color: white;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: 600;\n}\n\n.button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n    width: 100%;\n    padding: 12px;\n    border-radius: 8px;\n    border: 2px solid var(--glass-border-strong);\n    background: var(--glass-bg);\n    color: var(--color-white);\n    font-size: 1rem;\n}\n\n/* Native <select> dropdown options render with the OS popup background, which\n   is invisible/unreadable over a translucent glass select. Give them a solid,\n   theme-aware background so the option list is legible in every theme + mode. */\nselect option,\nselect optgroup {\n    background: var(--color-dark-lighter);\n    color: var(--color-white);\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n    color: var(--color-gray-light);\n}\n\n.form-group textarea {\n    resize: vertical;\n    min-height: 100px;\n}\n\n.loading {\n    text-align: center;\n    padding: 40px;\n    font-size: 1.2rem;\n}\n\n.error {\n    background: rgba(255, 0, 0, 0.2);\n    border: 2px solid rgba(255, 0, 0, 0.5);\n    border-radius: 8px;\n    padding: 15px;\n    margin-bottom: 20px;\n}\n\n.success {\n    background: rgba(0, 255, 0, 0.2);\n    border: 2px solid rgba(0, 255, 0, 0.5);\n    border-radius: 8px;\n    padding: 15px;\n    margin-bottom: 20px;\n}\n\n.battle-arena {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    gap: 20px;\n    margin: 40px 0;\n}\n\n.vs {\n    font-size: 3rem;\n    font-weight: bold;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.stats-bar {\n    background: var(--glass-bg);\n    border-radius: 8px;\n    padding: 15px;\n    margin-top: 20px;\n}\n\n.stat-item {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 0;\n    border-bottom: 1px solid var(--glass-border);\n}\n\n.stat-item:last-child {\n    border-bottom: none;\n}\n\n.badge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    margin-left: 8px;\n    color: white;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);\n}\n\n.badge.common {\n    background: #95a5a6;\n    color: white;\n}\n\n.badge.rare {\n    background: #3498db;\n    color: white;\n}\n\n.badge.epic {\n    background: #9b59b6;\n    color: white;\n}\n\n.badge.legendary {\n    background: #f39c12;\n    color: #1a1a1a;\n}\n\n.badge.limited {\n    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n    color: white;\n    box-shadow: 0 0 10px rgba(231, 76, 60, 0.5);\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
